import { NEW_FIXED_SERVICE_PRICE_RELEASE_DATE, NEW_SERVICE_PRICE_RELEASE_DATE } from './constants'

export const BOS_STATUS = Object.freeze({
    DRAFT: 'DRAFT',
    PENDING: 'PENDING',
    SIGNED: 'SIGNED',
    PAID: 'PAID',
    DELIVERED: 'DELIVERED',
    FINANCING: 'FINANCING',
    CONFIRMED: 'CONFIRMED',
    COMPLETED: 'COMPLETED',
    LOCKED: 'LOCKED',
    DISPUTED: 'DISPUTED',
    CANCELLED: 'CANCELLED',
})

export const PGW_STATUS = Object.freeze({
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    WAITING_APPROVAL: 'WAITING_APPROVAL',
    WAITING_REVIEW: 'WAITING_REVIEW',
    BLOCKED: 'BLOCKED',
    CLOSED: 'CLOSED',
})

export const BOS_TRAFI_TRANSFER_STATUS = Object.freeze({
    SUCCESS: 'SUCCESS',
    UNKNOWN: 'UNKNOWN',
    FAILED: 'FAILED',
})

export const BOS_DISPUTE_STATUS = Object.freeze({
    DISPUTE_CANCELLED: 'DISPUTE_CANCELLED',
    BOS_CONFIRMED: 'BOS_CONFIRMED',
    BOS_CANCELLED: 'BOS_CANCELLED',
})

export const BOS_USER_ENTERED_DELIVERY_STATUS = Object.freeze({
    COMPLETE: 'COMPLETE',
    PENDING: 'PENDING',
})

export const bosStatusNum = Object.freeze({
    [BOS_STATUS.DRAFT]: 0,
    [BOS_STATUS.PENDING]: 1,
    [BOS_STATUS.SIGNED]: 2,
    [BOS_STATUS.PAID]: 3,
    [BOS_STATUS.DELIVERED]: 4,
    [BOS_STATUS.CONFIRMED]: 5,
    [BOS_STATUS.COMPLETED]: 6,
})

export const getBosStatusNum = (status) => {
    return status in bosStatusNum ? bosStatusNum[status] : -1
}

export const BOS_PROCESS_STATE = Object.freeze({
    DRAFT: 'DRAFT',
    SIGNING: 'SIGNING',
    PAYMENT: 'PAYMENT',
    TRANSFERRAL: 'TRANSFERRAL',
    CONFIRMATION: 'CONFIRMATION',
    COMPLETION: 'COMPLETION',
})

export const BOS_USER_ROLE = Object.freeze({
    SELLER: 'SELLER',
    BUYER: 'BUYER',
    SIGNATORY: 'SIGNATORY',
    UNKNOWN: 'UNKNOWN',
    ADMIN: 'ADMIN',
})

export const SELLER_USER_ROLE = Object.freeze({
    OWNER: 'OWNER',
    HOLDER: 'HOLDER',
    USER: 'USER',
})

export const OWNER_PERSON_ROLE = Object.freeze({
    SELLER_USER: 'SELLER_USER',
    OWNER: 'OWNER',
    HOLDER: 'HOLDER',
    ACCREDITED: 'ACCREDITED',
})

export const BOS_SIGNING_TASK = Object.freeze({
    SELLER_SIGNATURE: 'SellerSignature',
    BUYER_SIGNATURE: 'BuyerSignature',
    SIGNATORY_SIGNATURE: 'SignatorySignature',
})

export const getRoleBySigningTask = (task) => {
    switch (task) {
    case BOS_SIGNING_TASK.SELLER_SIGNATURE:
        return BOS_USER_ROLE.SELLER
    case BOS_SIGNING_TASK.BUYER_SIGNATURE:
        return BOS_USER_ROLE.BUYER
    case BOS_SIGNING_TASK.SIGNATORY_SIGNATURE:
        return BOS_USER_ROLE.SIGNATORY
    default:
        throw new Error(`Invalid signing task "${task}"`)
    }
}

// Cases: https://docs.google.com/spreadsheets/d/1bmUh1tqdmoVowfqkIOOjhv0LSxEK_Fk2AxgJkHWYAQE/edit#gid=0
// TODO: Add link to gitbook instead
export const SELLER_FLOW_TYPE = Object.freeze({
    SellerLegacyOwner: 'SellerLegacyOwner', // Legacy for older bosses seller is owner (pre seller SELLER_FLOW_TYPE implementation)
    SellerLegacyOtherOwner: 'SellerLegacyOtherOwner', // Legacy for older bosses seller is not owner(pre seller SELLER_FLOW_TYPE implementation)
    SellerOwner: 'SellerOwner',
    SellerPartialOwner: 'SellerPartialOwner',
    SellerHolderOwner: 'SellerHolderOwner',
    SellerHolderFinanceCompany: 'SellerHolderFinanceCompany',
    SellerHolderCompanyAuthorize: 'SellerHolderCompanyAuthorize',
    SellerHolderCompanyNotAuthorize: 'SellerHolderCompanyNotAuthorize',
    SellerOtherOwner: 'SellerOtherOwner',
    SellerOtherMultipleOwner: 'SellerOtherMultipleOwner',
    SellerOtherFinanceCompany: 'SellerOtherFinanceCompany',
    SellerOtherCompanyAuthorize: 'SellerOtherCompanyAuthorize',
    SellerOtherCompanyNotAuthorize: 'SellerOtherCompanyNotAuthorize',
})

export const PAYMENT_FLOW_TYPE = Object.freeze({
    Online: 'Online',
    Cash: 'Cash',
    OnlineCash: 'OnlineCash',
    Credit: 'Credit',
    CreditOnline: 'CreditOnline',
    CreditCash: 'CreditCash',
    CreditOnlineCash: 'CreditOnlineCash',
})

export const DISPUTE_BY = Object.freeze({
    BUYER_ADMIN: 'BUYER_ADMIN',
    SELLER_ADMIN: 'SELLER_ADMIN',
    SELLER: 'SELLER',
    BUYER: 'BUYER',
    FINANCE_USER: 'FINANCE_USER'
})

export const isShowOldServiceFeeText = (bos) => {
    if (isShowFixedServiceFeeText(bos)) {
        return 1
    } else if (bos.createdAt < NEW_SERVICE_PRICE_RELEASE_DATE && bos.servicePayment === 2490) {
        return 2
    } else {
        return 3
    }
}

export const isShowFixedServiceFeeText = (bos) => {
    return bos.createdAt >= NEW_FIXED_SERVICE_PRICE_RELEASE_DATE
}
